(function() {
  'use strict';
  
  // Hàm di chuyển sản phẩm lên đầu
  function moveProductToFirst() {
    // Lấy parameter từ URL
    const urlParams = new URLSearchParams(window.location.search);
    const firstHandle = urlParams.get('first');
    
    if (!firstHandle) return; // Không có parameter thì thoát
    
    // Tìm grid container
    const productGrid = document.querySelector('#product-grid');
    if (!productGrid) return;
    
    // Tìm tất cả sản phẩm
    const allItems = Array.from(productGrid.querySelectorAll('.grid__item'));
    let featuredItem = null;
    
    // Tìm sản phẩm cần đưa lên đầu
    allItems.forEach(item => {
      const productLinks = item.querySelectorAll('a[href*="/products/"]');
      
      productLinks.forEach(link => {
        const href = link.getAttribute('href');
        if (href && href.includes(`/products/${firstHandle}`)) {
          featuredItem = item;
        }
      });
    });
    
    // Nếu tìm thấy, di chuyển lên đầu
    if (featuredItem && featuredItem.parentNode === productGrid) {
      // Di chuyển element lên đầu
      productGrid.insertBefore(featuredItem, productGrid.firstChild);
      
      // Reset animation index cho tất cả items
      const updatedItems = Array.from(productGrid.querySelectorAll('.grid__item'));
      updatedItems.forEach((item, index) => {
        item.style.setProperty('--index', index);
      });
      
      console.log('✅ Moved product to first position:', firstHandle);
    } else {
      console.log('⚠️ Product not found:', firstHandle);
    }
  }
  
  // Chạy khi DOM loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveProductToFirst);
  } else {
    moveProductToFirst();
  }
  
  // Chạy lại khi AJAX filtering/pagination xảy ra
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          moveProductToFirst();
        }
      });
    });
    
    const targetNode = document.querySelector('#ProductGridContainer');
    if (targetNode) {
      observer.observe(targetNode, { childList: true, subtree: true });
    }
  }
})();